var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseSmall = function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.5 6.44l4.5 4.5 4.5-4.5 1.06 1.06-4.5 4.5 4.5 4.5-1.06 1.06-4.5-4.5-4.5 4.5-1.06-1.06 4.5-4.5-4.5-4.5"
  })));
};
export default SvgCloseSmall;